export const GROUP_PROMPT_EXAMPLES: string[] = [
  // List open groups
  'Which group therapy sessions have open spots this week?',
  'Show me all DBT groups with availability',
  'List open trauma groups for adults',
  'Are there any telehealth groups with openings?',

  // Enrollment
  'Enroll Patient #4821 in the Tuesday DBT group',
  'Add Patient #3302 to the anxiety management group',
  'Check if Patient #7891 can join the Wednesday substance use group',

  // Attendance
  'Show attendance for the Monday trauma group',
  'Who attended last Tuesday\'s CBT group?',
  'How many no-shows did the grief group have this week?',

  // Conflict check
  'Does Patient #4821 have any conflicts with the Thursday group?',
  'Check Patient #3302 for scheduling conflicts before enrolling in the 10am group',
];
